import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-top-right-thick",
  "use": "arrow-top-right-thick-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-top-right-thick\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.796 4.205v4h6.818l-8.409 8.408 3.181 3.183 8.409-8.409v6.817h4V4.205z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol